<template>
<div role="group" class="b-form-group form-group">
  <div class="form-row">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('LABEL')">
        <inputvalidation :formerror="formError" name="label">
          <b-form-input type="text" v-model="formData.label"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm-12">
        <b-form-fieldset v-bind:label="$t('QUESTIONTYPE')">
            <inputvalidation :formerror="formError" name="questionType">
                <b-form-select :options="questionType" v-model="formData.questionType"></b-form-select>
            </inputvalidation>
        </b-form-fieldset>
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('ISREQUIRED')">
        <inputvalidation :formerror="formError" name="isRequired">
            <b-form-checkbox v-model="formData.isRequired" :value="1" :unchecked-value="0">{{$t('ISREQUIRED')}}</b-form-checkbox>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-6" v-if="formData.questionType === 'singleCombo' || formData.questionType === 'singleCombo'">
      <b-form-fieldset v-bind:label="$t('HASOTHER')">
        <inputvalidation :formerror="formError" name="hasOther">
            <b-form-checkbox v-model="formData.hasOther" :value="1" :unchecked-value="0">{{$t('HASOTHER')}}</b-form-checkbox>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row" v-if="formData.questionType === 'number' || formData.questionType === 'number'">
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('MIN')">
        <inputvalidation :formerror="formError" name="min">
            <b-form-input type="number" v-model="formData.min"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('MAX')">
        <inputvalidation :formerror="formError" name="max">
            <b-form-input type="number" v-model="formData.max"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div v-if="formData.questionType === 'singleCombo' || formData.questionType === 'multyCombo'">
    <template v-for="(value, key) in comboAnswers">
        <div class="form-row" :key="key">
            <div class="col-sm-9">
                <b-form-fieldset v-bind:label="`${$t('COMBOANSWER')} ${key+1}`">
                    <inputvalidation :formerror="formError" name="comboAnswers">
                        <b-form-input type="text" v-model="formData[`num_${value}`]"></b-form-input>
                    </inputvalidation>
                </b-form-fieldset>
            </div>
            <div class="col-sm-1">
                <b-form-fieldset v-bind:label="$t('ADD')">
                    <b-btn class="btn-bis btn-primary mt-label" @click="add(value)">+</b-btn>
                </b-form-fieldset>
            </div>
            <div class="col-sm-1" v-if="comboAnswers.length > 1">
                <b-form-fieldset v-bind:label="$t('REMOVE')">
                    <b-btn class="ml-2 btn-bis btn-delete mt-label" @click="remove(value)">-</b-btn>
                </b-form-fieldset>
            </div>
        </div>
    </template>
  </div>
</div>
</template>

<script>
export default {
    name: 'MeterValueForm',
    props: ['formData', 'formError'],
    data: function()
    {
        var me = this;
        return {
            comboAnswers: [0],
            questionType:
            [
                {
                    value: 'textfield',
                    text: me.$i18n.t('TEXTFIELD'),
                },
                {
                    value: 'number',
                    text: me.$i18n.t('NUMBER'),
                },
                {
                    value: 'textarea',
                    text: me.$i18n.t('TEXTAREA'),
                },
                {
                    value: 'singleCombo',
                    text: me.$i18n.t('SINGLECOMBO'),
                },
                {
                    value: 'multyCombo',
                    text: me.$i18n.t('MULTYCOMBO'),
                },
                {
                    value: 'checkbox',
                    text: me.$i18n.t('CHECKBOX'),
                },
                {
                    value: 'camera',
                    text: me.$i18n.t('CAMERA'),
                },
                {
                    value: 'barcode',
                    text: me.$i18n.t('BARCODE'),
                },
                {
                    value: 'nfc',
                    text: me.$i18n.t('NFC'),
                },
                {
                    value: 'qrcode',
                    text: me.$i18n.t('QRCODE'),
                },
                {
                  value: 'dateTime',
                  text: me.$i18n.t('DATETIME'),
                },
                {
                  value: 'date',
                  text: me.$i18n.t('DATE'),
                },
                {
                  value: 'time',
                  text: me.$i18n.t('TIME'),
                },
                {
                  value: 'signature',
                  text: me.$i18n.t('SIGNATURE'),
                },
            ],
        }
    },
    methods:
    {
        add(value)
        {
            const me = this;
            const new_val = value + 1;
            me.comboAnswers.push(new_val);
        },
        remove(value)
        {
            const me = this;
            delete (me.formData[`num_${value}`]);
            me.comboAnswers = me.comboAnswers.filter(item => item !== value)
        }
    },
    created()
    {
        const me = this;
        if (me.formData.comboAnswers != null)
        {
            if (me.formData.questionType != null
                && (me.formData.questionType === 'singleCombo' || me.formData.questionType === 'multyCombo'))
            {
                me.comboAnswers = [];
                for (let i = 0; i < me.formData.comboAnswers.length; i += 1)
                {
                    me.comboAnswers.push(i);
                    me.formData[`num_${i}`] = me.formData.comboAnswers[i];
                }

                me.comboAnswers.push(me.formData.comboAnswers.length);
            }

            if (me.formData.questionType != null
                && (me.formData.questionType === 'number'))
            {
                me.formData.max = me.formData.comboAnswers[0].max;
                me.formData.min = me.formData.comboAnswers[1].min;

            }
        }
    },
};
</script>

